import { render, staticRenderFns } from "./IconRecords.vue?vue&type=template&id=7ddc0bd9"
import script from "./IconRecords.vue?vue&type=script&lang=js"
export * from "./IconRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports